var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDowarrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    fill: "#FFF4ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.0834C23.7319 12.0834 25.5979 12.0834 26.7573 13.2427C27.9167 14.4021 27.9167 16.2681 27.9167 20C27.9167 23.732 27.9167 25.598 26.7573 26.7573C25.5979 27.9167 23.7319 27.9167 20 27.9167C16.268 27.9167 14.4021 27.9167 13.2427 26.7573C12.0833 25.598 12.0833 23.732 12.0833 20C12.0833 16.2681 12.0833 14.4021 13.2427 13.2427C14.4021 12.0834 16.268 12.0834 20 12.0834Z",
    stroke: "#FF6600",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1667 18.3334C24.1667 18.3334 21.098 21.6667 20 21.6667C18.902 21.6667 15.8333 18.3334 15.8333 18.3334",
    stroke: "#FF6600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDowarrow);
export default __webpack_public_path__ + "static/media/dowarrow.3f65a589061b8d36ca79a998596d8127.svg";
export { ForwardRef as ReactComponent };